import { AlertCircle } from "lucide-react";

export function DeleteConfirmModal({ category, onClose, onDisableInstead }) {
  if (!category) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-[#1E1E1E] rounded-2xl w-full max-w-md p-6">
        <div className="flex items-start gap-4 mb-6">
          <div className="w-12 h-12 bg-red-50 dark:bg-red-900/20 rounded-full flex items-center justify-center flex-shrink-0">
            <AlertCircle size={24} className="text-red-600 dark:text-red-400" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-[#111111] dark:text-white font-poppins mb-2">
              Cannot Delete Category
            </h3>
            <p className="text-sm text-[#666666] dark:text-[#A0A0A0] font-inter">
              <strong>{category.name}</strong> has{" "}
              <strong>{category.productsCount} products</strong> assigned to it.
              Please reassign or remove these products before deleting, or
              disable the category instead.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2.5 border border-[#E5E7EB] dark:border-[#2A2A2A] text-[#111111] dark:text-white rounded-lg font-medium text-sm font-inter transition-all hover:bg-[#F9FAFB] dark:hover:bg-[#262626] active:scale-95"
          >
            Cancel
          </button>
          <button
            onClick={onDisableInstead}
            className="flex-1 px-4 py-2.5 bg-orange-500 text-white rounded-lg font-semibold text-sm font-inter transition-all hover:bg-orange-600 hover:shadow-lg active:scale-95"
          >
            Disable Instead
          </button>
        </div>
      </div>
    </div>
  );
}
